import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { relayStylePagination } from '@apollo/client/utilities';

import { API_URL } from 'constants/Constants';
import { getAuthToken } from './localStorageService';

const httpLink = createHttpLink({
	uri: `${API_URL}/graphql`
});

const authLink = setContext((_, { headers }) => {
	// get the authentication token from local storage if it exists
	const token = getAuthToken();
	// return the headers to the context so httpLink can read them

	return {
		headers: {
			...headers,
			authorization: token ? `Bearer ${token}` : ''
		}
	};
});

const client = new ApolloClient({
	link: authLink.concat(httpLink),
	cache: new InMemoryCache({
		typePolicies: {
			Query: {
				fields: {
					profiles: relayStylePagination(),
					luceneQueries: relayStylePagination(),
					monitoredSources: relayStylePagination(),
					categories: relayStylePagination(),
					sourcePacks: relayStylePagination(),
					sites: relayStylePagination(),
					workspacePosts: relayStylePagination(),
					monitoredSourceLogs: relayStylePagination()
				}
			}
		}
	})
});

export default client;
